import { Radio, Users } from 'lucide-react';

export function StreamCard({ stream, isSelected, onSelect }) {
  return (
    <div 
      onClick={onSelect}
      className={`glass-card p-4 cursor-pointer border-2 transition-all ${
        isSelected 
          ? 'border-red-500 neon-glow' 
          : 'border-white/10 hover:border-red-500/50'
      }`}
      data-testid={`stream-${stream.id}`}
    >
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-lg bg-red-500/20 flex items-center justify-center">
          <Radio className="w-6 h-6 text-red-400" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold truncate">{stream.title}</h3>
            <span className="px-2 py-0.5 bg-red-500 rounded text-xs font-bold">LIVE</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-400 mt-1">
            <Users className="w-4 h-4" />
            <span>{stream.viewer_count} watching</span>
          </div>
        </div>
      </div>
    </div>
  );
}
